import React, { useEffect, useState } from "react";
import Header from "../../layout/header/header";
import Footer from "../../layout/footer/footer";
import bannerImg from "../../assets/banner-img.png";
import ads from "../../assets/ads.png";
import ofrIng from "../../assets/ofr-ing.png";
import h1 from "../../assets/h1.png";
import h2 from "../../assets/h2.png";
import i1 from "../../assets/i1.png";
import i2 from "../../assets/i2.png";
import group from "../../assets/Group.png";
import tImg from "../../assets/t-img.png";
import blogImg from "../../assets/blog-img.png";
import component from "../../assets/Component.png";
import "../home/home.css";

import { Link } from "react-router-dom";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
} from "@firebase/firestore";
import { db } from "../../firebase";
import { useAuth } from "../../auth/useAuth";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Home = () => {
  const [cities, setCities] = useState([]);
  const [userData, setUserData] = useState([]);
  const [userCity, setUserCity] = useState("");
  const [categories, setCategories] = useState({});
  const [subCategories, setSubCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [couponsList, setCouponsList] = useState([]);

  const { user } = useAuth();

  const [blogsData, setBlogsData] = useState([]);
  const [firstBlog, setFirstBlog] = useState({});
  const [threeBlogs, setThreeBlogs] = useState([]);

  useEffect(() => {
    fetchAllBlogs();
  }, []);

  useEffect(() => {
    if (blogsData && blogsData.length) {
      setFirstBlog(blogsData[0]);
    }
    const mThreeBlogs = [];
    for (let i = 0; i < blogsData.length; i++) {
      if (i === 0) continue;
      if (i > 3) break;
      mThreeBlogs.push(blogsData[i]);
    }
    setThreeBlogs(mThreeBlogs);
  }, [blogsData]);

  const fetchAllBlogs = async () => {
    const querySnapshot = await getDocs(collection(db, "blogs"));
    let mBlogs = [];
    querySnapshot.forEach((doc) => {
      mBlogs.push({ ...doc.data(), id: doc.id });
    });
    console.log("BLOGS: ", mBlogs);
    setBlogsData(mBlogs);
  };

  const fetchCities = async () => {
    const querySnapshot = await getDocs(collection(db, "cities"));
    let mCities = [];
    querySnapshot.forEach((doc) => {
      mCities.push({ ...doc.data(), id: doc.id });
    });
    console.log(mCities);
    setCities(mCities);
  };

  const fetchUserData = async () => {
    const docSnap = await getDoc(
      // doc(db, "users", "30INY5CrY1UEs4PfWlYKpdCU22F3")
      doc(db, "users", user.uid)
    );

    if (docSnap.exists()) {
      console.log("USER_DATA:", docSnap.data());
      setUserData(docSnap.data());
      if (docSnap.data().city !== undefined) {
        setUserCity(docSnap.data()?.city);
      }
    } else {
      // doc.data() will be undefined in this case
      console.log("No user found!");
      setUserData(null);
    }
  };

  const fetchCategories = async () => {
    const querySnapshot = await getDocs(collection(db, "categories"));
    let mCategories = {};
    querySnapshot.forEach((doc) => {
      let id = doc.id;
      mCategories[id] = doc.data();
    });
    console.log("CATEGORIES:", mCategories);
    setCategories(mCategories);
  };

  const fetchSubCategories = async () => {
    const querySnapshot = await getDocs(collection(db, "sub_categories"));
    let mSubCategories = {};
    querySnapshot.forEach((doc) => {
      let catId = doc.data().category_id;
      if (typeof mSubCategories[catId] === "undefined") {
        mSubCategories[catId] = [];
      }
      mSubCategories[catId].push({ id: doc.id, ...doc.data() });
    });
    console.log("SUB_CATEGORIES:", mSubCategories);
    setSubCategories(mSubCategories);
  };

  const fetchServices = async () => {
    const querySnapshot = await getDocs(collection(db, "services"));
    let mServices = [];
    querySnapshot.forEach((doc) => {
      mServices.push({ id: doc.id, ...doc.data() });
    });
    console.log("SERVICES:", mServices);
    setServices(mServices);
  };

  useEffect(() => {
    fetchCities();
    fetchCategories();
    fetchServices();
    fetchTestimonials();
    fetchAllCoupons();
  }, []);

  useEffect(() => {
    if (user && user.uid) {
      fetchUserData();
    }
  }, [user]);

  useEffect(() => {
    if (Object.keys(categories).length) {
      return fetchSubCategories();
    }
  }, [categories]);

  const setSelectedCity = async (index) => {
    if (user && user.uid) {
      await updateDoc(doc(db, "users", user.uid), {
        city: cities[index].id,
      });
      await fetchUserData();
    }
    localStorage.setItem("selected_city", JSON.stringify(cities[index]));
  };

  const getSelectedCity = (cityId) => {
    if (user && user.uid && userCity !== "") {
      return userCity === cityId;
    }
    return false;
  };

  const fetchTestimonials = async () => {
    const querySnapshot = await getDocs(collection(db, "testimonials"));
    let mTestimonials = [];
    querySnapshot.forEach((doc) => {
      mTestimonials.push({ id: doc.id, ...doc.data() });
    });
    console.log("SERVICES:", mTestimonials);
    setTestimonials(mTestimonials);
  };

  const fetchAllCoupons = async () => {
    const couponsRef = collection(db, "coupons");
    const querySnapshot = await getDocs(couponsRef);
    const mCouponsList = [];
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      mCouponsList.push({ id: doc.id, ...doc.data() });
    });
    setCouponsList(mCouponsList);
  };

  const history = useHistory();

  const formatAMPM = (date) => {
    var day = date.getDate();
    var month = date.getMonth();
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = `${day}/${month}/${year} ${hours} : ${minutes} ${ampm}`;
    return strTime;
  };

  return (
    <div>
      <div className="home_main">
        <Header />
        <section className="home_banner">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <h2>
                  Home Service <br />
                  On Demand
                </h2>
                <p>We are just one call away</p>
                <div className="bnr_btn d-flex">
                  <div className="btn_left">
                    <select
                      name="location"
                      id="location"
                      defaultValue={0}
                      onChange={(e) => setSelectedCity(e.target.value)}
                      // value={() => {
                      //   // TODO: not getting selected
                      //   if (user && user.uid && userData && userData.city) {
                      //     return cities.findIndex(
                      //       (mCity) => mCity.id === userData.city
                      //     );
                      //   } else {
                      //     if (localStorage.getItem("selected_city")) {
                      //       let { id } = JSON.parse(
                      //         localStorage.getItem("selected_city")
                      //       );
                      //       return cities.findIndex((mCity) => mCity.id === id);
                      //     }

                      //     return -1;
                      //   }
                      // }}
                    >
                      <option value={-1}>Location</option>
                      {cities.length
                        ? cities.map((mCityObj, index) => (
                            <option
                              key={mCityObj.id}
                              value={index}
                              selected={getSelectedCity(mCityObj.id)}
                            >
                              {mCityObj.name}
                            </option>
                          ))
                        : ""}
                    </select>
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                  </div>
                  <div className="btn_right">
                    <input
                      type="text"
                      className="search_box"
                      placeholder="Search for Link service"
                    />
                    <i className="fa fa-search" aria-hidden="true"></i>
                    <ul className="banner_list">
                      <li>
                        <Link href="#">Salon for men</Link>
                      </li>
                      <li>
                        <Link>,</Link>
                      </li>
                      <li>
                        <Link href="#">Ac servicing</Link>
                      </li>
                      <li>
                        <Link>,</Link>
                      </li>
                      <li>
                        <Link href="#">etc</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <img className="img-fluid" src={bannerImg} alt="img" />
              </div>
            </div>
          </div>
        </section>

        {/* <!-- salon for men --> */}
        <section className="salon_for_main">
          <div className="container-fluid">
            <div className="salon_men_inr">
              <ul>
                {services.length
                  ? services.map((mService) => (
                      <Link to={`/services/${mService.id}`} key={mService.id}>
                        <li>
                          <div className="salon_col">
                            <img
                              alt=""
                              className="img-fluid"
                              src={mService.icon}
                            />
                            <h4>{mService.name}</h4>
                          </div>
                        </li>
                      </Link>
                    ))
                  : ""}
              </ul>
            </div>
          </div>
        </section>
        {/* <!-- salon for men --> */}

        {/* <!-- ads section --> */}
        <section className="salon_ads">
          <div className="container-fluid">
            <img className="img-fluid" src={ads} alt="img" />
          </div>
        </section>

        {/* <!-- ads section --> */}

        {/* <!-- best offer --> */}
        <section className="best_offer">
          <div className="container-fluid">
            <h2>Best Offers</h2>
            <div className="row">
              {couponsList.length
                ? couponsList.map((mCoupon) => (
                    <div
                      className="col-sm-6 col-lg-3"
                      key={mCoupon.id}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        // copy to clipboard
                        navigator.clipboard.writeText(mCoupon.code);
                        alert(
                          `Coupon code ${mCoupon.code} copied to clipboard!`
                        );
                      }}
                    >
                      <div className="offer_inner">
                        <h4>{mCoupon.code}</h4>
                        <div className="rting_ofr d-flex">
                          <h6 className="mb-0">{mCoupon.description}</h6>
                        </div>
                      </div>
                    </div>
                  ))
                : ""}
            </div>
          </div>
        </section>
        {/* <!-- best ofr --> */}

        {/* <!-- GET Additional --> */}
        <section className="get_additional">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h3>
                  Get Additional 15% OFF
                  <br />
                  On our Mobile App.
                </h3>
              </div>
              <div className="col-md-6 col-lg-3">
                <img className="img-fluid mb-3" src={i1} alt="img" />
                <img className="img-fluid" src={i2} alt="img" />
              </div>
              <div className="col-md-6 col-lg-3 d-flex">
                <img className="img-fluid mr-5" src={h1} alt="img" />
                <img className="img-fluid" src={h2} alt="img" />
              </div>
            </div>
          </div>
        </section>
        {/* <!-- GET Additional --> */}

        {/* <!-- services start --> */}
        <section className="services">
          {/* <div className="container-fluid">
            <div className="row">
              <div className="col-lg-3">
                <div class="category_main">
                  <h3>Category</h3>
                  <div
                    class="panel-group"
                    id="accordion"
                    role="tablist"
                    aria-multiselectable="true"
                  >
                    {Object.keys(categories).length
                      ? Object.keys(categories).map((key) => (
                          <div key={key} class="panel panel-default">
                            <div
                              class="panel-heading"
                              role="tab"
                              id="headingOne"
                            >
                              <h4 class="panel-title">
                                <a
                                  role="button"
                                  data-toggle="collapse"
                                  data-parent="#accordion"
                                  href="#collapseOne"
                                  aria-expanded="true"
                                  aria-controls="collapseOne"
                                >
                                  <span>{categories[key].name}</span>
                                  <i
                                    class="fa fa-chevron-down"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </h4>
                            </div>
                            <div
                              id="collapseOne"
                              class="panel-collapse collapse in show"
                              role="tabpanel"
                              aria-labelledby="headingOne"
                            >
                              <div class="panel-body">
                                <ul class="service_list text-center">
                                  {typeof subCategories[key] !== "undefined"
                                    ? subCategories[key].map((subCat) => (
                                        <li key={subCat.id}>{subCat.name}</li>
                                      ))
                                    : ""}
                                </ul>
                              </div>
                            </div>
                          </div>
                        ))
                      : ""}
                  </div>
                </div>
              </div>
              <div className="col-lg-9">
                <h2 className="text-center heading_dgn">Best Offers</h2>
                <div className="row">
                  {couponsList.length
                    ? couponsList.map((mCoupon) => (
                        <div className="col-sm-6 col-lg-3" key={mCoupon.id}>
                          <div className="offer_inner">
                            <h4>{mCoupon.code}</h4>
                            <div className="rting_ofr d-flex">
                              <h6 className="mb-0">{mCoupon.description}</h6>
                            </div>
                          </div>
                        </div>
                      ))
                    : ""}
                </div>
              </div>
            </div>
          </div> */}
        </section>
        {/* <!--  --> */}

        {/* <!-- why choose us? --> */}
        <section className="why_choose_us">
          <div className="container-fluid">
            <h2 className="text-center heading_dgn">Why choose us?</h2>
            <div className="row">
              <div className="col-sm-6 col-lg-3">
                <div className="choose_us_inr">
                  <div className="img_div">
                    <img className="img-fluid" src={group} alt="img" />
                  </div>
                  <h5>Safety is our priority</h5>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="choose_us_inr">
                  <div className="img_div">
                    <img className="img-fluid" src={group} alt="img" />
                  </div>
                  <h5>Safety is our priority</h5>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="choose_us_inr">
                  <div className="img_div">
                    <img className="img-fluid" src={group} alt="img" />
                  </div>
                  <h5>Safety is our priority</h5>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="choose_us_inr">
                  <div className="img_div">
                    <img className="img-fluid" src={group} alt="img" />
                  </div>
                  <h5>Safety is our priority</h5>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--  --> */}

        {/* <!-- Testimonials --> */}
        <section className="testimonial_our_alient">
          <div className="container-fluid">
            <h2 className="text-center heading_dgn">
              Testimonials of our happy customers
            </h2>
            <div className="row">
              {testimonials.length
                ? testimonials.map((mTest) => (
                    <div className="col-sm-6 col-lg-4" key={mTest.id}>
                      <div className="testimonial_us_inr">
                        <div className="img_testimonial">
                          <img
                            className="img-fluid"
                            src={mTest.image || tImg}
                            alt="img"
                            style={{
                              width: "100%",
                              maxWidth: "100%",
                              height: "auto",
                            }}
                          />
                        </div>
                        <div className="testi_rating d-flex">
                          <i className="fa fa-star" aria-hidden="true"></i>
                          <i className="fa fa-star" aria-hidden="true"></i>
                          <i className="fa fa-star" aria-hidden="true"></i>
                          <i className="fa fa-star" aria-hidden="true"></i>
                          <i className="fa fa-star" aria-hidden="true"></i>
                        </div>
                        <div className="content_box">
                          <h4>
                            {mTest.name}{" "}
                            <span>
                              {formatAMPM(new Date(parseInt(mTest.date)))}
                            </span>
                          </h4>
                          <p>{mTest.content}</p>
                        </div>
                      </div>
                    </div>
                  ))
                : ""}
            </div>
          </div>
        </section>
        {/* <!--  --> */}

        {/* <!-- blog start --> */}
        <section className="blog_main">
          <div className="container-fluid">
            <h2 className="text-center heading_dgn">Blogs</h2>
            <div className="row">
              <div className="col-lg-7">
                {Object.keys(firstBlog).length ? (
                  <div
                    className="blogs_inner"
                    onClick={() =>
                      history.push({
                        pathname: `/blogs/${firstBlog.id}`,
                        state: { blogData: firstBlog },
                      })
                    }
                  >
                    <img
                      className="img-fluid"
                      src={firstBlog.image || blogImg}
                      alt="img"
                      style={{
                        width: "100%",
                        maxWidth: "100%",
                        height: "fit-content",
                      }}
                    />
                    <div className="blog_content">
                      <div className="con_top">
                        <h3>{firstBlog.title}</h3>
                        <span>
                          {formatAMPM(new Date(parseInt(firstBlog.date)))}
                          {/* <i className="fa fa-repeat" aria-hidden="true"></i>
                          <i
                            className="fa fa-cloud-download"
                            aria-hidden="true"
                          ></i> */}
                        </span>
                      </div>
                      <p>{firstBlog.content.substring(0, 299) + "..."}</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="col-lg-5">
                {threeBlogs.length
                  ? threeBlogs.map((blogObj, index) => (
                      <div
                        key={index}
                        className="blogs_inner_right"
                        onClick={() =>
                          history.push({
                            pathname: `/blogs/${blogObj.id}`,
                            state: { blogData: blogObj },
                          })
                        }
                      >
                        <div className="row">
                          <div className="col-4">
                            <img
                              className="img-fluid"
                              src={blogObj.image || blogImg}
                              alt="img"
                              style={{
                                width: "100%",
                                maxWidth: "100%",
                                height: "100%",
                              }}
                            />
                          </div>
                          <div className="col-8">
                            <div className="blog_content">
                              <h3>{blogObj.title}</h3>
                              <p>{blogObj.content.substring(0, 69) + "..."}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  : ""}
              </div>
            </div>
          </div>
        </section>
        {/* <!-- blog end --> */}

        {/* <!-- book highly --> */}
        <section className="book_highly">
          <div className="container-fluid">
            <div className="book_highly_inr">
              <div className="row">
                <div className="col-md-7">
                  <h2>
                    Book Highly recommended
                    <br />
                    Professionals from our App
                  </h2>
                  <div className="book_img d-flex align-items-center mb-4">
                    <img className="img-fluid mr-3" src={i1} alt="img" />
                    <img className="img-fluid" src={i2} alt="img" />
                  </div>
                </div>
                <div className="col-md-5 book_img_right d-flex">
                  <img className="img-fluid mr-5" src={h1} alt="img" />
                  <img className="img-fluid mt-3" src={h2} alt="img" />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- book highly --> */}

        <Footer />
      </div>
    </div>
  );
};

export default Home;
